import AppPage from '@/components/app-page/index.vue';
import EventManage from '../event-manage';
import EventManageRealtime from '../event-manage-realtime';
import Link from '../link-manage';

export default [{
  path: '/application-analysis',
  name: 'ApplicationAnalysis',
  component: AppPage,
  meta: {
    title: '应用分析',
    style: 'mobile-phone',
  },
  children: [
    // 概览
    {
      path: 'overview',
      name: 'ApplicationOverview',
      component: () => import('@/views/log/overview/index.vue'),
      meta: {
        title: '应用概况',
        style: 'monitor',
        activeMenu: '/log/overview',
        isUseAppInfo: true,
      },
    },
    {
      path: 'health',
      name: 'ApplicationHealth',
      component: () => import('@/views/log/health/index.vue'),
      meta: {
        title: '健康状态',
        style: 'sunny',
        activeMenu: '/log/health',
        isUseAppInfo: true,
      },
    },
    {
      path: 'errorReport',
      name: 'ApplicationAnalysisErrorReport',
      component: () => import('@/views/log/error-report/index.vue'),
      meta: {
        title: '错误异常',
        style: 'bell',
        activeMenu: '/log/errorReport',
        isNotMenu: true,
        isUseAppInfo: true,
      },
    },
    {
      path: 'errorReportDetail',
      name: 'ApplicationAnalysisErrorReportDetail',
      component: () => import('@/views/log/error-report/detail.vue'),
      meta: {
        title: '错误异常',
        style: 'bell',
        activeMenu: '/log/errorReport',
        isNotMenu: true,
        isUseAppInfo: true,
        isDisabledServerInfo: true,
        isDisabledAppInfo: true,
      },
    },
    ...EventManage,
    ...EventManageRealtime,
    ...Link,
  ],
}];
